import citiesList from './cities.json';

const citiesCache = {};
const latLonCache = {};

/**
 * **formatCities**_(cities)_<br>
 * Formats city results for dropdown options.
 * @param { Array } cities: List of cities to format.
 * @returns { Array } Formatted array of cities to display as dropdown options.
 */
export const formatCities = (cities) =>
  cities.map(({ co, lat, lon, state, value }) => {
    const stateText = state ? `${state}, ` : '';
    const subText = `${stateText}${co}`;
    return {
      subText,
      text: value,
      value: `${lat},${lon},${value}`,
    };
  });

/**
 * **getCitiesByName**_(cities)_<br>
 * Gets a list of cities matching a given input.
 * @param { String } name: The name of the city to search for.
 * @returns { Array } List of cities matching input name.
 */
export const getCitiesByName = (name) => {
  const key = name.toLowerCase();

  if (!citiesCache[key]) {
    const cities = citiesList.filter(({ value }) => value.toLowerCase().match(key));
    citiesCache[key] = cities;
  }
  return citiesCache[key];
};

/**
 * **getCityByLatLon**_(cities)_<br>
 * Gets a city object from a lat and lon value.
 * @param { String } lat: The latitude value of the city to search for.
 * @param { String } lon: The longitude value of the city to search for.
 * @returns { Object } The matching city object.
 */
export const getCityByLatLon = (lat, lon) => {
  const key = `${lat},${lon}`;

  if (!latLonCache[key]) {
    const city =
      citiesList.find(({ lat: cityLat, lon: cityLon }) => `${cityLat},${cityLon}` === key) || {};
    latLonCache[key] = city;
  }
  return latLonCache[key];
};

/**
 * getCurrentValue
 * Gets the current value of the dropdown if lat/lon value props match state when closed.
 * @returns { String } The current value of the dropdown.
 */
export const getCurrentValue = (
  { currentLat, currentLon, open, value } = { value: '' },
  { lat, lon } = {},
) => {
  return open || (currentLat === lat && currentLon === lon) ? value : '';
};

/**
 * determineDirection
 * IDetermine if a value is an upper, lower or no direction.
 * @param { String } upper: The upper direction.
 * @param { String } lower: The lower direction.
 * @param { Number } value: The number to check its direction.
 * @returns { String } The direction of the value.
 */
export const determineDirection = (upper, lower, value) => {
  if (value > 0) {
    return upper;
  }
  if (value < 0) {
    return lower;
  }
  return '';
};

/**
 * withinRange
 * If a given number is within the positve and negative limit.
 * @param { Number } value: The number to check if it's in range.
 * @param { Number } limit: The limit of the number.
 * @returns { Boolean } If the given value is within range.
 */
export const withinRange = (value, limit) =>
  (value >= limit * -1 && value <= limit) || value === '-';

/**
 * formatCityLabel
 * Formats the city label for the view mode popup.
 * @param { Object } city: The city to show.
 * @returns { String } The formatted city label.
 */
export const formatCityLabel = (city = {}) => {
  const { co, state, value } = city;
  const stateText = state ? `, ${state}` : '';
  const countryText = co ? `, ${co}` : '';
  return value ? `${value}${stateText}${countryText}` : '';
};
